import { createSlice } from '@reduxjs/toolkit';
import { authStorage } from '../utils/authStorage';
import { storageHelper } from '../utils/storageHelper';

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        ...authStorage.getInitialState(),
        authChecking: true // Start with auth checking true until we confirm state
    },
    reducers: {
        login: (state, action) => {
            const units = action.payload.units || [];
            state.isAuthenticated = true;
            state.token = action.payload.token;
            state.units = units;
            // Check the serial number of the active unit, and match it with the units array
            // If it matches, update activeUnit with the corresponding unit in the UnitsArray. If not, set to first unit in the array or null if none exist
            const activeUnit = state.activeUnit;
            if (activeUnit?.UnitSerNum) {
                const matchedUnit = units.find(unit => unit.UnitSerNum === activeUnit.UnitSerNum);
                state.activeUnit = matchedUnit || (units.length > 0 ? units[0] : null);
            } else {
                state.activeUnit = units.length > 0 ? units[0] : null;
            }
            state.isFirstLogin = action.payload.isFirstLogin;
            state.signedEula = action.payload.signedEula;
            state.userType = action.payload.user?.userType || null;
            state.user = action.payload.user || null;
            // Make sure to set authChecking to false upon login to prevent loops
            state.authChecking = false;
            // Store raw values in session storage
            sessionStorage.setItem('units', JSON.stringify(units));
            sessionStorage.setItem('activeUnit', JSON.stringify(state.activeUnit));
            sessionStorage.setItem('token', action.payload.token);
            sessionStorage.setItem('signedEula', action.payload.signedEula);
            sessionStorage.setItem('isFirstLogin', action.payload.isFirstLogin);
        },
        logout: (state) => {
            storageHelper.clear(); // Clear first
            Object.assign(state, authStorage.getInitialState()); // Then reset from empties
        },
        setActiveUnit: (state, action) => {
            state.activeUnit = action.payload;
            sessionStorage.setItem('activeUnit', JSON.stringify(action.payload));
        },
        setSignedEula: (state, action) => {
            state.signedEula = action.payload.signedEula;
            sessionStorage.setItem('signedEula', state.signedEula);
        },
        setFirstLogin: (state, action) => {
            state.isFirstLogin = action.payload;
            authStorage.updateStorage({
                isFirstLogin: action.payload
            });
        },
        setUserType: (state, action) => {
            state.userType = action.payload.userType;
        },
        setAuthChecking: (state, action) => {
            state.authChecking = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
            // Update session storage if user data changes
            if (action.payload) {
                sessionStorage.setItem('user', JSON.stringify(action.payload));
            }
        }
    },
});

export const { login, logout, setActiveUnit, setSignedEula, setFirstLogin, setUserType, setAuthChecking, setUser } = authSlice.actions;
export default authSlice.reducer;